let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("caNVK")).then(() => parcelRequire('4k0qc'));